import { FC } from 'react'
import { Badge, Box, IconButton, Typography, useTheme } from '@mui/material'
import { Link } from 'react-router-dom'
import { useIntl } from 'react-intl'
import R4RIcon from 'components/R4RIcon'
import { useUsersProfile } from 'services/profile/profile.hooks'
import { useNotificationsList } from 'services/notifications/notifications.hook'

// Desktop-only navy top bar from the "Panel Klienta 3.0" Figma design.
const TopBar: FC = () => {
  const theme = useTheme()
  const { formatMessage } = useIntl()
  const { userInitials } = useUsersProfile()
  const { hasUnread } = useNotificationsList()

  return (
    <Box
      component='header'
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: '56px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 28px',
        backgroundColor: theme.r4r.navy,
        zIndex: 102
      }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <Typography sx={{ color: '#fff', fontSize: '16px', fontWeight: 700, lineHeight: 1 }}>
          Resi4Rent
        </Typography>
        <Typography
          sx={{ color: '#fff', opacity: 0.5, fontSize: '10px', fontWeight: 500, lineHeight: 1 }}>
          {formatMessage({ id: 'dashboard.clientPanel', defaultMessage: 'Panel Klienta' })}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        <IconButton component={Link} to='/notifications' sx={{ color: '#fff', padding: 0 }}>
          <Badge
            variant='dot'
            invisible={!hasUnread}
            sx={{
              '.MuiBadge-badge': {
                backgroundColor: theme.r4r.red,
                minWidth: '8px',
                height: '8px',
                borderRadius: '4px'
              }
            }}>
            <R4RIcon name='bell' size={22} />
          </Badge>
        </IconButton>
        <IconButton component={Link} to='/user' sx={{ padding: 0 }}>
          <Box
            sx={{
              width: '32px',
              height: '32px',
              borderRadius: '16px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: 'rgba(255, 255, 255, 0.15)',
              color: '#fff',
              fontSize: '12px',
              fontWeight: 700
            }}>
            {userInitials}
          </Box>
        </IconButton>
      </Box>
    </Box>
  )
}

export default TopBar
